import keymirror from 'keymirror';

/**
 * App action types
 */
export const appActionTypes = keymirror({
	'UPDATE_LOCALE': null,
	'UPDATE_PREVIOUS_PAGE': null,
	'UPDATE_CURRENT_PAGE': null,
	'UPDATE_NEXT_PAGE': null,
	'UPDATE_NETWORK_STATUS': null,
	'UPDATE_DEVICE_TYPE': null,
});

/**
 * User action types
 */
export const userActionTypes = keymirror({
	'UPDATE_EMAIL_ADDRESS': null,
	'UPDATE_PASSWORD': null,
	'UPDATE_FIRSTNAME': null,
	'UPDATE_LASTNAME': null,
	'UPDATE_FB_LOGIN_SCOPE': null,
	'SET_PROPS_FROM_HOST': null,
});

/**
 * Validation action types
 */
export const validationActionTypes = keymirror({
	'UPDATE_VALIDATION_ERRORS': null,
});


/**
 * HTTP action types
 */
export const httpActionTypes = keymirror({
	'FACEBOOK_REQUEST_MADE': null,
	'FACEBOOK_REQUEST_SUCCESS': null,
	'FACEBOOK_REQUEST_ERROR': null,
	'IAM_REQUEST_MADE': null,
	'IAM_REQUEST_SUCCESS': null,
	'IAM_REQUEST_ERROR': null,
});

/**
 * FACEBOOK action types
 */
export const facebookActionTypes = keymirror({
	'UPDATE_FACEBOOK_LOGIN_STATUS': null,
	'UPDATE_FACEBOOK_FIRST_NAME': null,
	'UPDATE_FACEBOOK_LAST_NAME': null,
	'UPDATE_FACEBOOK_EMAIL': null,
	'UPDATE_FACEBOOK_ACCESS_TOKEN': null,
});

/**
 * AUTH action types
 */
export const authActionTypes = keymirror({
	'UPDATE_AUTH_TOKEN': null,
});






// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/actions/actionTypes.js